export default __webpack_public_path__ + "static/media/c001-ngo-5.ca15ea72.jpg";